<div class="app-card">
  <h5 class="card-title h5 fw-bold mb-4">Manage Tags</h5>

  @if (!contactId) {
    <div class="text-center text-muted py-5">
      Please provide a Contact ID to manage tags.
    </div>
  }

  @if (contactId) {
    <div class="space-y-4">
      <!-- Section for Tags attached to the current contact -->
      <div class="mb-4">
        <h6 class="h6 fw-bold text-dark mb-2">Attached Tags</h6>
        @if (loading()) {
          <div class="text-muted">Loading...</div>
        }
        @if (!loading() && attachedTags().length === 0) {
          <div class="text-muted small">
            No tags are attached to this contact.
          </div>
        }
        <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
          @for (tag of attachedTags(); track tag) {
            <span
              class="badge bg-danger text-light fs-6 rounded-pill d-flex align-items-center px-3 py-2 me-1">
              {{ tag.name }}
              <button (click)="detachTag(tag.id)" class="btn btn-sm text-light p-0 ms-2" style="line-height: 1; border: none; background: transparent;">
                &times;
              </button>
            </span>
          }
        </div>
      </div>
      <!-- Section for Available Tags to attach -->
      <div class="mb-4">
        <h6 class="h6 fw-bold text-dark mb-2">Available Tags</h6>
        @if (loading()) {
          <div class="text-muted">Loading...</div>
        }
        @if (!loading() && availableTags().length === 0) {
          <div class="text-muted small">
            All tags are attached to this contact.
          </div>
        }
        <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
          @for (tag of availableTags(); track tag) {
            <button
              (click)="attachTag(tag.id)"
              class="badge bg-light text-dark fs-6 rounded-pill d-flex align-items-center px-3 py-2 me-1">
              + {{ tag.name }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>